import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import AssignedToColumn from '../../../components/columns/assigned-to-column';
import Global from '../../../store/global-selectors';
import { messages } from '../messages';

const AssignedTo = ({ fulfillmentId }) => {
  const { fulfillmentPlanId } = useSelector((state) => Global.selectEntitiesFulfillmentById(state, { fulfillmentId })) ?? {};

  const assignedToUserId = useSelector((state) =>
    Global.selectEntitiesFulfillmentPlanProperty(state, {
      fulfillmentPlanId,
      property: 'assignedToUserId',
    }),
  );

  if (!assignedToUserId) {
    return '';
  }
  return <AssignedToColumn userId={assignedToUserId} />;
};

AssignedTo.propTypes = {
  fulfillmentId: PropTypes.string.isRequired,
};

export const assignedTo = {
  getMessageDescriptor: () => messages.assignedTo,
  name: <FormattedMessage {...messages.assignedTo} />,
  id: 'assignedTo',
  render: (data) => <AssignedTo fulfillmentId={data.id} />,
};
